import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { groundTruthMapping } from '../../apis/EnergyEfficient/EfficientApi';
import { useSelector } from "react-redux";
import { useEffect } from 'react';
import {toast} from "react-toastify"
// Utility to transform appliance names to CamelCase (remove spaces/hyphens, capitalize each word)
function toCamelCase(str) {

  return str
    .replace(/[- ]+/g, ' ') // replace hyphens and multiple spaces with single space
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).replace(/[^a-zA-Z0-9]/g, ''))
    .join('');
}

// Replace HOME_APPLIANCES with readable names and a mapping
const HOME_APPLIANCES = [
  "Air Conditioner", "Air Purifier", "Air Fryer", "Baby Monitor", "Bar Chiller", "Bathroom Water Heater", "Bedside Lamp", "Blender", "Bluetooth Speaker", "Bottle Warmer", "Bread Maker", "Bulbs", "Ceiling Fan", "Ceiling Light", "Chandelier", "Coffee Maker", "Decoder", "Deep Freezer", "Deep Fryer", "Dehumidifier", "Digital Clock", "DVD Player", "Electric Blanket", "Electric Blinds", "Electric Clipper", "Electric Chopper", "Electric Cooker", "Electric Curtains", "Electric Grill", "Electric Heater", "Electric Hot Plate", "Electric Iron", "Electric Kettle", "Electric Oven", "Electric Sandwich Maker", "Electric Steamer", "Electric Toothbrush", "Espresso Machine", "Exercise Bike", "Exhaust Fan", "Freezer", "Food Processor", "Game Console", "Hair Dryer", "Hair Straightener", "Hand Dryer", "Heated Recliner", "Home Theatre System", "Humidifier", "Juicer", "Laptop", "Laptop Charger", "Laser Star Projector", "LED Strip Lights", "Massage Chair", "Microwave", "Mixer", "Monitor", "Night Light", "Power Backup Display Unit", "Phone Charger", "Popcorn Machine", "Pressure Cooker", "Printer", "Projector", "Refrigerator", "Rice Cooker", "Robot Vacuum Docking Station", "Rolling Machine", "Scanner", "Standing Fan", "Standing Lamp", "Security Camera", "Smart Speaker", "Smoothie Maker", "Sound System", "Stereo System", "Streaming Device", "Soundbar", "Table Lamp", "Tablet Charger", "Toaster", "Treadmill", "TV", "TV Backlight System", "UPS", "UV Sterilizer", "Vacuum Cleaner", "Voltage Stabilizer", "VR Headset", "Waffle Maker", "Washing Machine", "Water Dispenser", "Water Heater", "Water Purifier", "WiFi Router", "Wine Cooler", "Wireless Charging Pad", "Yoghurt Maker"
];

// Map display name to value (camel case)
const HOME_APPLIANCE_VALUE_MAP = {
  "Air Conditioner": "AirConditioner",
  "Air Purifier": "AirPurifier",
  "Air Fryer": "AirFryer",
  "Baby Monitor": "BabyMonitor",
  "Bar Chiller": "BarChiller",
  "Bathroom Water Heater": "BathroomWaterHeater",
  "Bedside Lamp": "BedsideLamp",
  "Blender": "Blender",
  "Bluetooth Speaker": "BluetoothSpeaker",
  "Bottle Warmer": "BottleWarmer",
  "Bread Maker": "BreadMaker",
  "Bulbs": "Bulbs",
  "Ceiling Fan": "CeilingFan",
  "Ceiling Light": "CeilingLight",
  "Chandelier": "Chandelier",
  "Coffee Maker": "CoffeeMaker",
  "Decoder": "Decoder",
  "Deep Freezer": "DeepFreezer",
  "Deep Fryer": "DeepFryer",
  "Dehumidifier": "Dehumidifier",
  "Digital Clock": "DigitalClock",
  "DVD Player": "DVDPlayer",
  "Electric Blanket": "ElectricBlanket",
  "Electric Blinds": "ElectricBlinds",
  "Electric Clipper": "ElectricClipper",
  "Electric Chopper": "ElectricChopper",
  "Electric Cooker": "ElectricCooker",
  "Electric Curtains": "ElectricCurtains",
  "Electric Grill": "ElectricGrill",
  "Electric Heater": "ElectricHeater",
  "Electric Hot Plate": "ElectricHotPlate",
  "Electric Iron": "ElectricIron",
  "Electric Kettle": "ElectricKettle",
  "Electric Oven": "ElectricOven",
  "Electric Sandwich Maker": "ElectricSandwichMaker",
  "Electric Steamer": "ElectricSteamer",
  "Electric Toothbrush": "ElectricToothbrush",
  "Espresso Machine": "EspressoMachine",
  "Exercise Bike": "ExerciseBike",
  "Exhaust Fan": "ExhaustFan",
  "Freezer": "Freezer",
  "Food Processor": "FoodProcessor",
  "Game Console": "GameConsole",
  "Hair Dryer": "HairDryer",
  "Hair Straightener": "HairStraightener",
  "Hand Dryer": "HandDryer",
  "Heated Recliner": "HeatedRecliner",
  "Home Theatre System": "HomeTheatreSystem",
  "Humidifier": "Humidifier",
  "Juicer": "Juicer",
  "Laptop": "Laptop",
  "Laptop Charger": "LaptopCharger",
  "Laser Star Projector": "LaserStarProjector",
  "LED Strip Lights": "LEDStripLights",
  "Massage Chair": "MassageChair",
  "Microwave": "Microwave",
  "Mixer": "Mixer",
  "Monitor": "Monitor",
  "Night Light": "NightLight",
  "Power Backup Display Unit": "PowerBackupDisplayUnit",
  "Phone Charger": "PhoneCharger",
  "Popcorn Machine": "PopcornMachine",
  "Pressure Cooker": "PressureCooker",
  "Printer": "Printer",
  "Projector": "Projector",
  "Refrigerator": "Refrigerator",
  "Rice Cooker": "RiceCooker",
  "Robot Vacuum Docking Station": "RobotVacuumDockingStation",
  "Rolling Machine": "RollingMachine",
  "Scanner": "Scanner",
  "Standing Fan": "StandingFan",
  "Standing Lamp": "StandingLamp",
  "Security Camera": "SecurityCamera",
  "Smart Speaker": "SmartSpeaker",
  "Smoothie Maker": "SmoothieMaker",
  "Sound System": "SoundSystem",
  "Stereo System": "StereoSystem",
  "Streaming Device": "StreamingDevice",
  "Soundbar": "Soundbar",
  "Table Lamp": "TableLamp",
  "Tablet Charger": "TabletCharger",
  "Toaster": "Toaster",
  "Treadmill": "Treadmill",
  "TV": "TV",
  "TV Backlight System": "TVBacklightSystem",
  "UPS": "UPS",
  "UV Sterilizer": "UVSterilizer",
  "Vacuum Cleaner": "VacuumCleaner",
  "Voltage Stabilizer": "VoltageStabilizer",
  "VR Headset": "VRHeadset",
  "Waffle Maker": "WaffleMaker",
  "Washing Machine": "WashingMachine",
  "Water Dispenser": "WaterDispenser",
  "Water Heater": "WaterHeater",
  "Water Purifier": "WaterPurifier",
  "WiFi Router": "WiFiRouter",
  "Wine Cooler": "WineCooler",
  "Wireless Charging Pad": "WirelessChargingPad",
  "Yoghurt Maker": "YoghurtMaker"
};

const FACILITY_APPLIANCES = [
  "Access Control System", "Air Conditioner", "Anaesthesia Machines", "Antenna Systems", "Autoclaves", "Bedside X-Ray Machine", "Blenders Mixers", "Blood Analyzer", "Bulbs", "CCTV", "Ceiling Fan", "Centrifuges", "Charging Station", "Centrifuge Machines", "CNC Machine", "Coffee Makers", "Cold Storage Units", "Compressors", "Conveyor Belt", "CT Scanners", "Defibrillators", "Desktop Computers", "Dialysis Machines", "Dryers", "ECG Machines", "Electric Bells", "Electric Cookers Induction Hobs", "Electric Fencing", "Electric Kettles", "Electronic Massage Chairs", "Electrosurgical Units", "Elevator Systems", "ELISA Readers", "Environmental Monitoring Systems", "Floodlights", "Fiber Optic Transceivers", "Fire Suppression Systems", "Fume Extractors", "Game Console", "Hospital Bed With Electric Controls", "Humidifier", "HVAC Systems", "Incubators", "Infusion Pumps", "Injection Molding Machines", "Intercoms", "Inventory Systems RFID Tablets", "Juicer", "Laptop", "Lab Indicators Oven", "Laptop Charger", "Led Light", "Mammography Machine", "Measurement Tools", "Metal Detectors", "Microscopes", "Microwave", "Monitor", "MR Machine", "Night Light", "Optical Line Terminals", "Oscilloscopes", "Oxygen Concentrators", "PACS Servers Monitors", "Patient Monitors", "Photocopiers", "Printer", "Projector", "Rack Mounted Power Units", "Refrigerator", "Remote Radio Units RRUs", "RFID Systems", "Robotic Arms", "Sauna Spa Heaters", "Smart Boards", "Scanners", "Servers", "Shredders", "Sound System", "Speakers", "Spectrometers", "Standing Fan", "Suction Machines", "Surgical Lights", "Syringe Pumps", "Toasters Grills", "Treadmills Gym Machines", "TVs", "Ultrasound Machines", "UPS", "UV Disinfection Lamps", "Ventilators", "VoIP IP Telephony Systems", "Voltage Stabilizers", "Washer Disinfectors", "Water Baths", "Water Heaters", "Water Machine", "Welding Machines", "X-Ray Machine"
];

const FACILITY_APPLIANCE_VALUE_MAP = {
  "Access Control System": "AccessControlSystem",
  "Air Conditioner": "AirConditioner",
  "Anaesthesia Machines": "AnaesthesiaMachines",
  "Antenna Systems": "AntennaSystems",
  "Autoclaves": "Autoclaves",
  "Bedside X-Ray Machine": "BedsideXRayMachine",
  "Blenders Mixers": "BlendersMixers",
  "Blood Analyzer": "BloodAnalyzer",
  "Bulbs": "Bulbs",
  "CCTV": "CCTV",
  "Ceiling Fan": "CeilingFan",
  "Centrifuges": "Centrifuges",
  "Charging Station": "ChargingStation",
  "Centrifuge Machines": "CentrifugeMachines",
  "CNC Machine": "CNCMachine",
  "Coffee Makers": "CoffeeMakers",
  "Cold Storage Units": "ColdStorageUnits",
  "Compressors": "Compressors",
  "Conveyor Belt": "ConveyorBelt",
  "CT Scanners": "CTScanners",
  "Defibrillators": "Defibrillators",
  "Desktop Computers": "DesktopComputers",
  "Dialysis Machines": "DialysisMachines",
  "Dryers": "Dryers",
  "ECG Machines": "ECGMachines",
  "Electric Bells": "ElectricBells",
  "Electric Cookers Induction Hobs": "ElectricCookersInductionHobs",
  "Electric Fencing": "ElectricFencing",
  "Electric Kettles": "ElectricKettles",
  "Electronic Massage Chairs": "ElectronicMassageChairs",
  "Electrosurgical Units": "ElectrosurgicalUnits",
  "Elevator Systems": "ElevatorSystems",
  "ELISA Readers": "ELISAReaders",
  "Environmental Monitoring Systems": "EnvironmentalMonitoringSystems",
  "Floodlights": "Floodlights",
  "Fiber Optic Transceivers": "FiberOpticTransceivers",
  "Fire Suppression Systems": "FireSuppressionSystems",
  "Fume Extractors": "FumeExtractors",
  "Game Console": "GameConsole",
  "Hospital Bed With Electric Controls": "HospitalBedWithElectricControls",
  "Humidifier": "Humidifier",
  "HVAC Systems": "HVACSystems",
  "Incubators": "Incubators",
  "Infusion Pumps": "InfusionPumps",
  "Injection Molding Machines": "InjectionMoldingMachines",
  "Intercoms": "Intercoms",
  "Inventory Systems RFID Tablets": "InventorySystemsRFIDTablets",
  "Juicer": "Juicer",
  "Laptop": "Laptop",
  "Lab Indicators Oven": "LabIndicatorsOven",
  "Laptop Charger": "LaptopCharger",
  "Led Light": "LedLight",
  "Mammography Machine": "MammographyMachine",
  "Measurement Tools": "MeasurementTools",
  "Metal Detectors": "MetalDetectors",
  "Microscopes": "Microscopes",
  "Microwave": "Microwave",
  "Monitor": "Monitor",
  "MR Machine": "MRMachine",
  "Night Light": "NightLight",
  "Optical Line Terminals": "OpticalLineTerminals",
  "Oscilloscopes": "Oscilloscopes",
  "Oxygen Concentrators": "OxygenConcentrators",
  "PACS Servers Monitors": "PACSServersMonitors",
  "Patient Monitors": "PatientMonitors",
  "Photocopiers": "Photocopiers",
  "Printer": "Printer",
  "Projector": "Projector",
  "Rack Mounted Power Units": "RackMountedPowerUnits",
  "Refrigerator": "Refrigerator",
  "Remote Radio Units RRUs": "RemoteRadioUnitsRRUs",
  "RFID Systems": "RFIDSystems",
  "Robotic Arms": "RoboticArms",
  "Sauna Spa Heaters": "SaunaSpaHeaters",
  "Smart Boards": "SmartBoards",
  "Scanners": "Scanners",
  "Servers": "Servers",
  "Shredders": "Shredders",
  "Sound System": "SoundSystem",
  "Speakers": "Speakers",
  "Spectrometers": "Spectrometers",
  "Standing Fan": "StandingFan",
  "Suction Machines": "SuctionMachines",
  "Surgical Lights": "SurgicalLights",
  "Syringe Pumps": "SyringePumps",
  "Toasters Grills": "ToastersGrills",
  "Treadmills Gym Machines": "TreadmillsGymMachines",
  "TVs": "TVs",
  "Ultrasound Machines": "UltrasoundMachines",
  "UPS": "UPS",
  "UV Disinfection Lamps": "UVDisinfectionLamps",
  "Ventilators": "Ventilators",
  "VoIP IP Telephony Systems": "VoIPIPTelephonySystems",
  "Voltage Stabilizers": "VoltageStabilizers",
  "Washer Disinfectors": "WasherDisinfectors",
  "Water Baths": "WaterBaths",
  "Water Heaters": "WaterHeaters",
  "Water Machine": "WaterMachine",
  "Welding Machines": "WeldingMachines",
  "X-Ray Machine": "XRayMachine"
};

function CustomCheckbox({ checked, onChange, label }) {
  return (
    <label className="custom-checkbox flex items-center gap-2 h-[32px] cursor-pointer select-none">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="hidden"
      />
      <span className="checkbox-box flex items-center justify-center">
        {checked && (
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 8.5L7 11.5L12 5.5" stroke="#038B47" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )}
      </span>
      <span className="text-[19px] text-[#10182A]">{label}</span>
    </label>
  );
}

export default function EfficiencyUpdate() {
  // const auth = useSelector((state) => state.auth);
  const auth = useSelector((state) => state.auth);

  // console.log("auth", auth);


  const navigate = useNavigate()
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const [facilityDropdownOpen, setFacilityDropdownOpen] = useState(false);
  const [facilitySelected, setFacilitySelected] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [others, setOthers] = useState('');
  const [showOverlay, setShowOverlay] = useState(false);
  const [applianceVoltages, setApplianceVoltages] = useState({});
  const [formError, setFormError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState(null);

  const closeOverlay = () => setShowSuccess(false);
  const toggleDropdown = () => setDropdownOpen((v) => !v);
  const handleCheck = (appliance) => {
    setSelected((prev) =>
      prev.includes(appliance)
        ? prev.filter((a) => a !== appliance)
        : [...prev, appliance]
    );
  };

  const toggleFacilityDropdown = () => setFacilityDropdownOpen((v) => !v);
  const handleFacilityCheck = (appliance) => {
    setFacilitySelected((prev) =>
      prev.includes(appliance)
        ? prev.filter((a) => a !== appliance)
        : [...prev, appliance]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowOverlay(true);
  };

  // Combine all selected appliances for overlay
  const allAppliances = [
    ...selected,
    ...facilitySelected,
    ...(others ? [others] : [])
  ];

  // Handle voltage input change
  const handleVoltageChange = (appliance, value) => {
    setApplianceVoltages((prev) => ({ ...prev, [appliance]: value }));
  };

  const buildPayload = () => {
    const homeAppliances = [];
    const facilityAppliances = [];
    const othersArr = [];

    selected.forEach((appliance, idx) => {
      homeAppliances.push({
        name: appliance,
        voltage: Number(applianceVoltages[appliance + idx])
      });
    });

    facilitySelected.forEach((appliance, idx) => {
      facilityAppliances.push({
        name: appliance,
        voltage: Number(applianceVoltages[appliance + idx])
      });
    });

    if (others) {
      const othersList = others.split(',').map(item => item.trim()).filter(Boolean);
      othersList.forEach((other, i) => {
        othersArr.push({
          name: other,
          voltage: Number(applianceVoltages[other + (selected.length + facilitySelected.length + i)])
        });
      });
    }

    return {
      homeAppliances,
      facilityAppliances,
      others: othersArr
    };
  };
  useEffect(() => {
    

  })

  const moveToDashboard= () => navigate("/efficiency-home")

  const homeApplianceInputs = selected.map((appliance, idx) => (
    <label key={appliance + idx} className="flex   text-gray-700 text-xl font-medium  mx-auto">
<div className='w-40 flex-shrink-0'>
<span className="mb-2 w-32 break-words">{appliance}</span>

</div>
      <input
        type="text"
        className="border ml-5 border-gray-300 rounded-md px-5 py-2 focus:outline-none focus:ring-2 focus:ring-green-400 bg-gray-50 w-48 text-center"
        value={applianceVoltages[appliance + idx] || ''}
        onChange={e => handleVoltageChange(appliance + idx, e.target.value)}
      />
    </label>
  ));

  const facilityApplianceInputs = facilitySelected.map((appliance, idx) => (
    <label
      key={appliance + idx}
      className="flex items-center text-gray-700 text-xl font-medium mx-auto"
    >
      <div className="w-40 flex-shrink-0">
        <span className="block w-32 mr-10  break-words ">
          {appliance}
        </span>
      </div>
      <input
        type="text"
        className="border border-gray-300 rounded-md px-5 py-2 focus:outline-none focus:ring-2 focus:ring-green-400 bg-gray-50 w-48 text-center ml-5"
        value={applianceVoltages[appliance + idx] || ''}
        onChange={e => handleVoltageChange(appliance + idx, e.target.value)}
      />
    </label>
  ));

  const othersList = others.split(',').map(item => item.trim()).filter(Boolean);
  const othersInputs = othersList.map((other, i) => (
    <label key={other + i} className="flex  items-center text-gray-700 text-xl font-medium  mx-auto">
      <div className='w-40 flex-shrink-0'>
      <span className="mb-2 w-32 break-words">{other}</span>

      </div>

      <input
        type="text "
        className="border border-gray-300 rounded-md px-5 py-2 focus:outline-none focus:ring-2 focus:ring-green-400 bg-gray-50 w-48 text-center"
        value={applianceVoltages[other + (selected.length + facilitySelected.length + i)] || ''}
        onChange={e => handleVoltageChange(other + (selected.length + facilitySelected.length + i), e.target.value)}
      />

    </label>
  ));

  const handleOverlayFormSubmit = async (e) => {

    e.preventDefault();
    // Validate all voltage fields
    const allVoltages = [
      ...selected.map((a, i) => applianceVoltages[a + i]),
      ...facilitySelected.map((a, i) => applianceVoltages[a + i]),
      ...othersList.map((o, i) => applianceVoltages[o + (selected.length + facilitySelected.length + i)])
    ];
    if (allVoltages.some(v => !v || isNaN(Number(v)))) {
      setFormError('Please enter a valid voltage for every appliance.');
      return;
    }
    setFormError('');
    const payload = buildPayload();

    setIsLoading(true);
    setApiError(null);
    try {
      const response = await groundTruthMapping(payload, auth?.token);
      console.log(payload)
      setShowOverlay(false);
      setShowSuccess(true);
      toast.info("Your facility Historical baseline will be ready in 10mins, it's been calculated from the KYC you provided.");
      console.log("API Success:", response.data);
    } catch (error) {
      setApiError(error?.message || "API Error");
      console.error("API Error:", error);
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="p-10 relative">
      {/* Overlay for voltage input */}
      {showOverlay && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30"
          role="dialog"
          aria-modal="true"
        >
          <div className="bg-white rounded-xl shadow-lg p-10 w-[936px] max-w-full relative">
            <button
              className="absolute top-6 right-6 text-gray-400 hover:text-red-500 text-2xl"
              onClick={() => setShowOverlay(false)}
              aria-label="Close overlay"
            >
              &times;
            </button>
            <h2 className="text-2xl font-bold mb-2 text-gray-900">You're almost done</h2>
            <p className="text-gray-500 mb-8">Input the power in watts for each of the appliance you selected</p>
            <form onSubmit={handleOverlayFormSubmit} autoComplete="off">
              <div className="grid grid-cols-2 gap-x-8 gap-y-4 mb-8">
                {/* Home Appliances */}
                {homeApplianceInputs.length > 0 && (
                  <>
                    <div className="col-span-2 text-lg font-bold text-green-700 mb-2">Home Appliances</div>
                    {homeApplianceInputs}
                  </>
                )}
                {/* Facility Appliances */}
                {facilityApplianceInputs.length > 0 && (
                  <>
                    <div className="col-span-2 text-lg font-bold text-blue-700 mt-4 mb-2">Facility Appliances</div>
                    {facilityApplianceInputs}
                  </>
                )}
                {/* Others */}
                {othersInputs.length > 0 && (
                  <>
                    <div className="col-span-2 text-lg font-bold text-gray-700 mt-4 mb-2">Others</div>
                    {othersInputs}
                  </>
                )}
              </div>
              {/* Error message */}
              {formError && (
                <div className="text-red-500 text-center mb-4">{formError}</div>
              )}
              {apiError && (
                <div className="text-red-500 text-center mb-4">{apiError}</div>
              )}
              <button
                type="submit"
                className="w-full text-lg py-10 text-white font-semibold rounded bg-gradient-to-r from-[#038B47] to-[#00AED9] hover:from-green-700 hover:to-green-600 transition-all shadow"
                disabled={isLoading}
              >
                {isLoading ? 'Submitting...' : 'Submit'}
              </button>
            </form>
          </div>
        </div>
      )}
      {/* Success Overlay */}
      {showSuccess && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 ">
          <div className="bg-white  rounded-xl shadow-lg max-w-lg w-full flex flex-col items-center relative animate-fade-in p-10 m-28">
            {/* Close button */}
            <button
            
              className="absolute top-4 right-4 text-red-400 hover:text-red-600 text-2xl"
              onClick={moveToDashboard}
              aria-label="Close"
            >
              ×
            </button>
            {/* Confetti SVG */}
            <div className="mb-2">
            <svg width="224" height="262" viewBox="0 0 224 262" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="224" height="262" fill="white"/>
<circle opacity="0.05" cx="117" cy="141.004" r="92" fill="#038B47"/>
<path d="M113.724 169.239C109.257 169.238 104.854 168.177 100.877 166.143C96.8998 164.109 93.4619 161.161 90.8457 157.54C88.2295 153.919 86.5096 149.729 85.8274 145.315C85.1451 140.9 85.52 136.387 86.9212 132.145C88.3223 127.904 90.7098 124.055 93.8875 120.916C97.0652 117.776 100.942 115.435 105.201 114.086C109.459 112.736 113.976 112.416 118.382 113.151C122.788 113.887 126.957 115.657 130.546 118.317C131.026 118.707 131.337 119.268 131.415 119.882C131.492 120.496 131.329 121.116 130.961 121.613C130.592 122.11 130.046 122.446 129.436 122.55C128.826 122.655 128.199 122.52 127.686 122.174C123.45 119.029 118.277 117.405 113.004 117.564C107.731 117.724 102.665 119.657 98.627 123.052C94.5887 126.447 91.8136 131.105 90.7504 136.272C89.6873 141.44 90.3983 146.815 92.7685 151.528C95.1387 156.241 99.0295 160.017 103.812 162.245C108.594 164.473 113.988 165.023 119.121 163.806C124.254 162.589 128.827 159.675 132.1 155.537C135.372 151.399 137.153 146.278 137.155 141.002C137.151 139.767 137.051 138.533 136.854 137.314C136.805 136.998 136.819 136.676 136.895 136.366C136.97 136.055 137.106 135.763 137.295 135.505C137.483 135.247 137.721 135.029 137.993 134.863C138.266 134.697 138.569 134.587 138.885 134.538C139.2 134.489 139.522 134.503 139.833 134.578C140.143 134.654 140.435 134.79 140.693 134.978C140.951 135.167 141.169 135.404 141.335 135.677C141.501 135.95 141.611 136.253 141.66 136.569C141.875 138.036 141.976 139.519 141.961 141.002C141.954 148.489 138.977 155.668 133.683 160.962C128.389 166.256 121.211 169.233 113.724 169.239Z" fill="#34A853"/>
<path d="M116.73 150.014C116.094 150.012 115.484 149.757 115.036 149.305L103.621 137.89C103.227 137.431 103.021 136.839 103.045 136.235C103.068 135.63 103.319 135.056 103.747 134.628C104.175 134.2 104.749 133.949 105.353 133.926C105.958 133.903 106.55 134.108 107.009 134.502L116.73 144.211L145.676 115.277C146.135 114.883 146.727 114.678 147.331 114.701C147.936 114.724 148.51 114.975 148.938 115.403C149.366 115.831 149.617 116.405 149.64 117.01C149.663 117.614 149.458 118.206 149.064 118.665L118.424 149.305C117.975 149.757 117.366 150.012 116.73 150.014Z" fill="#34A853"/>
<path opacity="0.1" d="M140.765 41.0497C139.905 40.8142 139.047 40.8237 138.067 40.8346C137.822 40.8373 137.577 40.84 137.331 40.8427C138.545 39.7266 139.758 38.6105 140.601 37.2534C140.842 36.8832 140.347 36.5211 140.105 36.7689C138.647 37.8877 137.312 39.1277 135.978 40.3677C135.96 38.7751 135.943 37.1826 135.925 35.59C135.917 34.855 134.814 34.8672 134.822 35.6022C134.84 37.1948 134.859 38.9098 134.877 40.5024C133.761 39.4121 132.648 38.4443 131.534 37.4765C131.04 37.1144 130.434 37.7337 130.928 38.0958C131.797 39.0663 132.665 40.0368 133.657 41.006C132.431 41.0196 131.206 41.0332 129.982 41.1692C129.492 41.1747 129.5 41.9097 129.99 41.9043C131.462 42.0105 132.81 41.9955 134.158 41.9806C133.066 42.9728 131.975 44.0876 131.007 45.201C130.522 45.6965 131.264 46.3008 131.75 45.9279C132.842 44.9356 133.936 44.0659 134.905 43.075C134.92 44.4225 134.936 45.8926 135.196 47.2374C135.199 47.4824 135.689 47.477 135.809 47.2306C136.041 46.0028 136.026 44.6553 136.011 43.3078C136.381 43.5487 136.63 43.9135 137.001 44.1544C137.743 44.7588 138.485 45.3632 139.225 45.845C139.473 46.0873 139.837 45.7157 139.589 45.4734C138.968 44.7452 138.47 44.0156 137.849 43.2874C137.476 42.8014 136.982 42.4394 136.61 42.0759C137.223 42.0691 137.713 42.0637 138.325 42.0569C139.306 42.046 140.041 42.0379 141.019 41.782C141.14 41.6582 141.134 41.1681 140.765 41.0497Z" fill="#030229"/>
<path opacity="0.1" d="M14.009 102.873C13.1485 102.637 12.2907 102.647 11.3104 102.657C11.0653 102.66 10.8202 102.663 10.5751 102.666C11.7883 101.549 13.0015 100.433 13.8444 99.0763C14.0854 98.7061 13.5911 98.344 13.3488 98.5917C11.7666 99.5894 10.4336 100.952 9.0992 102.192C9.08154 100.599 9.06389 99.0068 9.04624 97.4142C9.03809 96.6792 7.93522 96.6914 7.94336 97.4265C7.96102 99.019 7.98003 100.734 7.99768 102.327C6.88259 101.236 5.76885 100.268 4.65511 99.3007C4.16087 98.9386 3.55496 99.5579 4.0492 99.92C4.91785 100.891 5.7865 101.861 6.7777 102.83C5.55228 102.844 4.32687 102.857 3.10281 102.993C2.61265 102.999 2.62079 103.734 3.11096 103.728C4.58282 103.835 5.93077 103.82 7.27873 103.805C6.18672 104.797 5.09607 105.912 4.12796 107.025C3.64322 107.521 4.38526 108.125 4.87135 107.752C5.96336 106.76 7.05673 105.89 8.0262 104.899C8.04114 106.247 8.05743 107.717 8.31745 109.062C8.32017 109.307 8.81033 109.301 8.93016 109.055C9.16166 107.827 9.14673 106.48 9.13179 105.132C9.50213 105.373 9.75129 105.738 10.1216 105.979C10.8637 106.583 11.6057 107.187 12.3464 107.669C12.5942 107.912 12.9577 107.54 12.7099 107.298C12.0891 106.569 11.5908 105.84 10.9699 105.112C10.5969 104.626 10.1026 104.264 9.73092 103.9C10.3436 103.893 10.8338 103.888 11.4465 103.881C12.4268 103.87 13.1621 103.862 14.1397 103.606C14.2609 103.482 14.2554 102.992 14.009 102.873Z" fill="#030229"/>
<path d="M34.6396 62.3363C33.2835 61.6163 32.05 60.8948 31.056 59.6806C29.9382 58.3453 29.4304 56.7582 28.6775 55.1738C28.6775 55.1738 28.6762 55.0513 28.5536 55.0527L28.4311 55.054C28.4311 55.054 28.4311 55.054 28.3099 55.1779C28.3099 55.1779 28.3099 55.1779 28.3112 55.3004C27.9803 58.6121 26.0454 60.9614 23.6177 63.0711C23.4965 63.195 23.4992 63.44 23.6231 63.5611C26.3326 64.7563 28.2074 68.0435 29.0951 70.7291C29.2203 70.9727 29.5879 70.9687 29.7078 70.7223C30.1803 69.1243 30.5316 67.6502 31.3731 66.1706C32.2146 64.6911 33.3052 63.5763 34.6437 62.7038C34.7649 62.58 34.7622 62.335 34.6396 62.3363Z" fill="#54B785"/>
<path d="M221.892 99.0838C220.536 98.3637 219.302 97.6423 218.431 96.4267C217.313 95.0914 216.805 93.5043 216.053 91.9199C216.053 91.9199 216.051 91.7974 215.929 91.7988L215.806 91.8001C215.806 91.8001 215.806 91.8001 215.685 91.924C215.685 91.924 215.685 91.924 215.686 92.0465C215.355 95.3582 213.42 97.7075 210.993 99.8172C210.871 99.9411 210.874 100.186 210.998 100.307C213.708 101.502 215.582 104.79 216.47 107.475C216.595 107.719 216.963 107.715 217.083 107.468C217.555 105.87 217.907 104.396 218.748 102.917C219.59 101.437 220.68 100.322 222.019 99.4499C222.019 99.4499 222.016 99.2049 221.892 99.0838Z" fill="#54B785"/>
<path d="M132.094 68.9595C131.109 68.4804 130.368 67.9985 129.623 67.1491C128.877 66.1772 128.497 65.0788 127.872 63.983C127.872 63.983 127.872 63.983 127.75 63.9844L127.627 63.9857C127.627 63.9857 127.627 63.9857 127.628 64.1082C127.409 66.4385 126.079 68.046 124.38 69.5351C124.258 69.659 124.26 69.7815 124.382 69.7801C126.352 70.6159 127.604 72.9299 128.237 74.7607C128.239 75.0057 128.607 75.0016 128.604 74.7566C128.837 73.6513 129.193 72.5447 129.794 71.5579C130.396 70.5711 131.123 69.8279 132.097 69.2045C132.22 69.2032 132.217 68.9581 132.094 68.9595Z" fill="#54B785"/>
<path d="M100.837 90.8069C99.112 89.9683 97.7545 89.1258 96.6353 87.6679C95.2684 85.9678 94.6353 84.1371 93.7558 82.1865C93.7558 82.1865 93.7544 82.064 93.6319 82.0654L93.5093 82.0667C93.5093 82.0667 93.3868 82.0681 93.3882 82.1906L93.3895 82.3131C92.9428 86.2386 90.6471 89.2046 87.7333 91.6872C87.6121 91.8111 87.6162 92.1786 87.8613 92.1759C91.1862 93.6093 93.4354 97.5049 94.4524 100.802C94.579 101.168 95.0692 101.162 95.1876 100.794C95.6574 98.9505 96.2498 97.1062 97.2111 95.3803C98.1724 93.6543 99.5054 92.2918 101.21 91.2928C100.965 91.2955 101.084 90.9266 100.837 90.8069Z" fill="#54B785"/>
<path d="M71.4503 59.9516C69.7076 57.5206 67.9662 55.212 65.7388 53.2764C64.5025 52.31 63.2662 51.3435 61.9101 50.6234C61.1708 50.2641 60.4328 50.0272 59.6935 49.6679C59.3245 49.5494 58.9555 49.431 58.5852 49.1901C58.2162 49.0716 57.9684 48.8293 57.6021 48.9559C57.357 48.9586 57.2359 49.0825 57.3611 49.3261C57.4904 49.9373 58.2298 50.2967 58.724 50.6587C59.3421 51.142 59.9589 51.5027 60.5771 51.9859C61.812 52.8299 63.0483 53.7963 64.162 54.7641C66.2669 56.7011 68.0056 58.7646 69.6244 61.0746C70.3719 62.1689 72.1992 61.1685 71.4503 59.9516Z" fill="#FF8F6B"/>
<path d="M70.577 109.105C69.5708 106.788 67.229 105.589 64.8898 104.635C62.5507 103.68 59.8453 102.853 57.3985 103.248C55.0729 103.518 52.5158 105.017 51.6825 107.231C51.0874 108.831 50.5005 111.165 51.9846 112.374C52.728 113.101 54.0773 113.208 54.8044 112.465C56.0176 111.349 54.8957 109.646 53.9059 108.8C49.8213 105.169 42.9658 105.858 38.4548 107.991C35.6499 109.247 33.2222 111.357 31.7829 114.191C30.582 116.409 29.2775 120.344 30.8963 122.654C31.1455 123.019 31.6356 123.014 31.8766 122.643C33.2042 120.791 33.1743 118.096 34.1329 116.125C35.0902 114.031 36.6642 112.299 38.4901 111.176C42.2617 108.684 48.7429 107.387 52.6941 110.038C53.1883 110.4 54.5458 111.243 53.8187 111.986C53.2127 112.605 52.2256 112.004 51.8526 111.518C50.3522 108.839 53.8733 105.859 56.0723 105.223C58.2712 104.586 60.8514 105.17 62.9441 106.004C65.2805 106.713 67.9914 108.031 69.3611 109.976C69.9765 110.214 70.8288 109.715 70.577 109.105Z" fill="#EF37FF"/>
<path d="M178.16 89.6449C178.282 89.6436 178.281 89.5211 178.158 89.5224C178.036 89.5238 178.037 89.6463 178.16 89.6449Z" fill="#3F3937"/>
<path d="M179.24 87.5489C181.28 83.6056 185.523 79.393 190.318 80.81C192.039 81.281 194.263 82.8491 194.042 85.0569C193.936 86.5283 192.209 85.5673 191.59 84.9616C190.102 83.3853 190.806 80.5596 191.275 78.7166C191.983 76.2584 193.551 73.9131 195.618 72.42C197.318 71.0534 199.64 70.4151 201.72 70.147C204.046 69.8762 206.137 70.5881 208.348 71.0537C209.207 71.1667 209.809 70.1799 209.19 69.5741C207.578 67.8767 204.757 67.663 202.554 67.9324C200.228 68.2032 197.784 68.8429 195.838 70.2122C191.945 72.8283 189.066 78.3735 189.485 83.0246C189.753 85.1045 192.492 88.9947 194.796 86.7638C195.888 85.7716 195.5 83.9381 194.996 82.7185C194.118 80.8904 192.144 79.6871 190.3 79.2175C184.77 77.8086 180.532 82.5113 178.501 87.1895C178.382 87.5584 178.999 87.9191 179.24 87.5489Z" fill="#EF37FF"/>
<path d="M73.2249 82.4897C71.4821 80.0586 69.256 78.2455 66.6691 77.049C65.3143 76.4514 63.9609 75.9763 62.6103 75.7463C61.3821 75.5148 59.5426 75.4127 58.4466 76.0375C58.2028 76.1627 58.2069 76.5302 58.4547 76.7725C59.4418 77.3741 60.9137 77.4803 62.0193 77.7131C63.3713 78.0657 64.4783 78.421 65.7105 79.0199C68.051 80.0966 70.2744 81.6647 71.8891 83.6072C72.51 84.3354 73.8471 83.3404 73.2249 82.4897Z" fill="#FF8F6B"/>
<path d="M45.2537 91.0071C46.3539 90.7499 47.5779 90.6138 48.6808 90.6016C49.2935 90.5948 49.9062 90.588 50.5189 90.5812C50.8866 90.5771 51.2542 90.5731 51.4979 90.4478C51.7416 90.3226 51.9867 90.3199 52.2304 90.1947C52.4742 90.0694 52.4701 89.7019 52.2236 89.5821C51.9772 89.4624 51.7308 89.3426 51.6069 89.2214C51.3604 89.1016 50.8703 89.1071 50.6238 88.9873C50.0111 88.9941 49.3984 89.0009 48.6645 89.1315C47.4405 89.2676 46.2178 89.5262 44.9964 89.9073C44.2625 90.038 44.5198 91.1378 45.2537 91.0071Z" fill="#FF8F6B"/>
<path d="M175.803 120.178C179.211 118.057 182.868 116.301 186.777 115.155C188.61 114.645 190.565 114.133 192.523 113.867C193.625 113.732 194.604 113.598 195.705 113.464C196.563 113.454 197.421 113.445 198.152 113.069C198.396 112.944 198.392 112.576 198.145 112.457C197.283 112.099 196.427 112.231 195.447 112.241C194.344 112.254 193.365 112.387 192.262 112.399C190.18 112.545 188.101 112.935 186.023 113.449C181.868 114.475 178.212 116.353 174.81 119.086C174.326 119.582 175.072 120.554 175.803 120.178Z" fill="#FF8F6B"/>
<path d="M168.999 114.494C171.906 111.398 175.682 109.274 179.335 107.15C181.162 106.15 183.111 105.026 185.062 104.146C186.159 103.644 187.134 103.143 188.109 102.642C189.084 102.142 190.184 101.884 191.158 101.261C191.402 101.136 191.397 100.768 191.028 100.65C190.045 100.416 188.947 100.795 187.968 100.929C186.744 101.065 185.645 101.445 184.547 101.947C182.352 102.951 180.159 104.078 178.089 105.326C174.07 107.576 170.542 109.943 167.764 113.65C167.281 114.268 168.392 114.99 168.999 114.494Z" fill="#FF8F6B"/>
<path d="M148.87 56.5211C148.744 56.155 148.739 55.7875 148.611 55.2988C148.609 55.0538 148.485 54.9327 148.483 54.8101C148.482 54.6876 148.481 54.5651 148.357 54.444C148.356 54.3215 148.233 54.3228 148.232 54.2003C148.108 54.0792 147.984 53.9581 147.861 53.9594C147.739 53.9608 147.618 54.0846 147.496 54.2085C147.498 54.331 147.375 54.3324 147.377 54.4549C147.378 54.5774 147.379 54.6999 147.381 54.8224C147.383 55.0674 147.386 55.3124 147.511 55.556C147.515 55.9236 147.642 56.2897 147.769 56.6559L147.767 56.5334L147.769 56.6559C147.77 56.7784 147.895 57.022 148.019 57.1432C148.143 57.2643 148.389 57.3841 148.511 57.2602C148.633 57.2589 148.877 57.1336 148.876 57.0111C148.876 57.0111 148.873 56.7661 148.87 56.5211Z" fill="#030229"/>
<path d="M153.967 74.11C154.054 70.9236 155.003 68.0951 156.074 65.1428C156.67 63.6659 157.268 62.3116 157.988 60.9559C158.708 59.6002 159.431 58.4895 159.783 57.0154C159.78 56.7704 159.531 56.4056 159.289 56.6533C158.681 57.1501 158.318 57.5217 157.834 58.1397C157.474 58.7563 157.114 59.4954 156.753 60.112C156.034 61.5902 155.315 63.0684 154.72 64.6677C153.65 67.62 153.074 70.9344 152.987 74.1209C153.116 74.7321 153.974 74.7225 153.967 74.11Z" fill="#FF8F6B"/>
<path d="M164.275 53.4122C164.395 53.1658 164.516 53.0419 164.636 52.7956C164.636 52.7956 164.638 52.9181 164.515 52.9194C164.515 52.9194 164.514 52.7969 164.636 52.7956L164.757 52.6717C164.879 52.5479 164.879 52.5478 165 52.424C165.241 52.0538 165.606 51.8047 165.847 51.4344C166.088 51.0642 166.453 50.8151 166.694 50.4449C166.813 50.1985 167.057 50.0733 167.177 49.827C167.176 49.7045 167.298 49.7031 167.297 49.5806C167.418 49.4567 167.417 49.3342 167.415 49.2117C167.535 48.9654 167.286 48.6006 166.918 48.6046C166.796 48.606 166.673 48.6073 166.428 48.6101C166.306 48.6114 166.307 48.7339 166.184 48.7353C166.184 48.7353 166.184 48.7353 166.062 48.7366C166.184 48.7353 166.184 48.7353 166.062 48.7366C165.817 48.7394 165.574 48.9871 165.331 49.1123C164.843 49.3627 164.48 49.7343 164.116 50.1059C163.753 50.4775 163.389 50.8491 163.149 51.3418C162.908 51.7121 162.546 52.2061 162.428 52.575C162.187 52.9452 162.316 53.5564 162.809 53.796C163.546 53.9103 164.034 53.7824 164.275 53.4122Z" fill="#FF8F6B"/>
<path d="M160.241 76.3677C160.598 75.3835 161.078 74.5206 161.435 73.5365C161.792 72.5524 162.15 71.6908 162.629 70.7053C163.11 69.8423 163.467 68.8582 163.947 67.9953C164.428 67.1323 165.154 66.2666 165.266 65.2852C165.261 64.9177 164.892 64.7993 164.647 64.802C163.67 65.0579 163.192 66.1659 162.587 66.9077C161.862 67.7734 161.382 68.7588 160.903 69.7443C160.424 70.7298 160.067 71.7139 159.711 72.8205C159.594 73.3119 159.355 73.8046 159.361 74.4171C159.244 74.9085 159.251 75.521 159.257 76.011C159.141 76.6249 160.001 76.8604 160.241 76.3677Z" fill="#FF8F6B"/>
<path d="M166.956 62.9371C167.194 62.3218 167.556 61.8277 167.919 61.3337C168.401 60.5932 168.636 59.7329 169.119 59.115C169.603 58.497 170.213 58.2452 170.82 57.7484C171.427 57.2516 172.035 56.7548 172.641 56.1355C174.944 53.9046 177.619 51.9147 180.419 50.2909C181.151 49.9152 181.882 49.5396 182.613 49.1639C183.1 48.9135 183.83 48.4153 183.456 47.8068C182.83 46.5886 180.396 48.2083 179.665 48.584C176.864 50.2078 174.562 52.5612 172.012 54.6723C171.282 55.1704 170.676 55.7897 170.07 56.409C169.464 57.0284 168.983 57.8913 168.377 58.5106C167.772 59.1299 167.04 59.5056 166.434 60.1249C165.95 60.6204 165.59 61.3595 165.353 62.0972C164.874 63.0827 166.355 64.0464 166.956 62.9371Z" fill="#FF8F6B"/>
<path opacity="0.5" d="M108.944 70.073C109.424 69.0876 109.533 67.8612 109.398 66.76C109.384 65.535 109.248 64.3113 108.991 63.2115C108.988 62.9665 108.498 62.9719 108.501 63.2169C108.39 64.3208 108.403 65.4233 108.416 66.6484C108.427 67.6284 108.439 68.7309 108.081 69.5925C107.843 70.2078 108.706 70.6883 108.944 70.073Z" fill="#EF37FF"/>
<g opacity="0.5">
<path d="M109.011 54.1464C108.999 53.0438 109.109 51.9399 108.976 50.9613C108.841 49.8601 108.463 48.8841 107.839 47.9109C107.714 47.6672 107.225 47.7952 107.352 48.1613C107.864 50.116 107.887 52.1985 107.91 54.2811C107.794 54.895 109.019 54.8814 109.011 54.1464Z" fill="#EF37FF"/>
</g>
<path opacity="0.5" d="M103.501 43.6701C103.245 42.6928 102.867 41.7168 102.367 40.8647C102.118 40.4999 101.99 40.0113 101.741 39.6465C101.492 39.2817 101.238 38.5494 100.748 38.5548C100.503 38.5575 100.258 38.5602 100.138 38.8066C99.8986 39.2993 100.272 39.7853 100.522 40.2726C100.771 40.6374 101.022 41.1247 101.148 41.4908C101.648 42.3429 102.025 43.1964 102.28 44.0512C102.533 44.7835 103.754 44.4024 103.501 43.6701Z" fill="#EF37FF"/>
<path opacity="0.5" d="M109.12 41.8928C109.355 40.91 109.465 39.8061 109.575 38.7022C109.57 38.2122 109.563 37.5997 109.558 37.1097C109.552 36.6197 109.545 36.0072 109.295 35.5199C109.168 35.1537 108.678 35.1591 108.56 35.528C108.32 36.0207 108.327 36.6333 108.332 37.1233C108.338 37.6133 108.343 38.1033 108.348 38.5933C108.359 39.5734 108.248 40.5548 108.136 41.5361C108.139 41.7811 108.265 42.1473 108.51 42.1446C108.758 42.3869 109.124 42.2603 109.12 41.8928Z" fill="#EF37FF"/>
<path opacity="0.5" d="M113.816 45.3939C114.047 44.1662 114.525 43.0582 115.127 42.0714C115.729 41.0845 116.577 40.2175 117.302 39.2293C117.422 38.983 117.295 38.6168 117.051 38.742C115.707 39.1245 114.739 40.2379 114.139 41.3472C113.416 42.4579 113.063 43.8095 112.832 45.0373C112.595 45.775 113.702 46.1303 113.816 45.3939Z" fill="#EF37FF"/>
<path d="M194.87 93.5014C194.991 93.3776 194.99 93.2551 195.111 93.1312C195.231 92.8848 195.351 92.6385 195.348 92.3935C195.345 92.1485 195.344 92.026 195.464 91.7796L195.462 91.6571C195.461 91.5346 195.459 91.4121 195.458 91.2896C195.455 91.0446 195.453 90.7996 195.327 90.5559C195.325 90.3109 195.201 90.1897 195.077 90.0686C194.826 89.5813 194.332 89.2192 193.718 89.1035C193.965 89.2233 194.211 89.3431 194.459 89.5854C194.211 89.3431 193.965 89.2233 193.719 89.226C193.473 89.1062 193.228 89.1089 193.107 89.2328C192.862 89.2355 192.74 89.3594 192.497 89.4846C192.253 89.6098 192.009 89.735 191.888 89.8589C191.767 89.9828 191.646 90.1066 191.525 90.2305C191.526 90.353 191.403 90.3544 191.405 90.4769C191.406 90.5994 191.285 90.7232 191.286 90.8457C191.407 90.7219 191.405 90.4769 191.526 90.353C191.527 90.4755 191.405 90.4769 191.406 90.5994C191.407 90.7219 191.285 90.7232 191.286 90.8457C191.165 90.9696 191.168 91.2146 191.047 91.3385C190.927 91.5848 190.807 91.8312 190.811 92.1987C190.691 92.4451 190.818 92.8112 190.821 93.0562C190.946 93.2999 191.071 93.5435 191.196 93.7872C191.322 94.0308 191.569 94.2731 191.816 94.3929C191.94 94.5141 192.185 94.5113 192.309 94.6325C192.678 94.7509 193.168 94.7455 193.534 94.6189C193.655 94.495 193.9 94.4923 194.022 94.3685C194.509 94.118 194.75 93.7478 194.87 93.5014Z" fill="#FF8F6B"/>
<path d="M189.988 51.0425C189.986 50.92 189.864 50.9213 189.862 50.7988C189.739 50.6777 189.615 50.5565 189.613 50.434C189.613 50.434 189.489 50.3129 189.367 50.3142C189.12 50.1945 189.119 50.072 188.75 49.9535C188.628 49.9549 188.381 49.8351 188.259 49.8365C188.136 49.8378 187.891 49.8405 187.891 49.8405L187.525 49.9671C187.281 50.0923 187.16 50.2162 187.04 50.4626C186.919 50.5864 186.919 50.5864 186.92 50.7089C186.921 50.8314 186.799 50.8328 186.8 50.9553C186.68 51.2017 186.562 51.5705 186.566 51.938C186.57 52.3055 186.695 52.5492 186.822 52.9154C187.196 53.5238 187.813 53.8845 188.426 53.8777C189.039 53.8709 189.77 53.4953 190.008 52.88C190.128 52.6337 190.246 52.2648 190.242 51.8973C190.24 51.6523 190.114 51.4086 189.988 51.0425Z" fill="#FF8F6B"/>
<path d="M99.8351 66.7441C98.8181 63.4474 99.2689 59.8893 99.8449 56.5749C99.8422 56.3299 99.5958 56.2101 99.476 56.4565C98.2872 59.7777 97.9617 63.5794 98.98 66.9986C98.9868 67.6111 99.9644 67.3553 99.8351 66.7441Z" fill="#030229"/>
</svg>

              
            </div>
            <div className="text-3xl font-semibold text-center mb-2 text-gray-900">Submission successful</div>
            <div className="text-gray-500 text-center text-base mb-2">
              You've successfully completed your Ground Truth Mapping. We'll use this data to evaluate your energy efficiency performance.
            </div>
          </div>
        </div>
      )}
      {/* Info Alert */}
      <div className="flex items-center justify-between border border-green-300 bg-green-50 rounded-md px-5 py-5 mb-8">
        <div className="flex items-center pr-96 pl-10 ">
          <svg className="w-10 h-10 text-green-600 mr-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/><path d="M12 8v4m0 4h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          <span className="text-xl text-gray-900">Your facility Historical baseline will be ready in 10mins, it's been calculated from the KYC you provided.</span>
        </div>
        <button className="text-gray-400 hover:text-gray-600 ml-52 ">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      {/* Card */}
      <div className="bg-white rounded-lg border-radius-8px;
border solid bg-[#FCFCFC]; mt-20 pt-10 pb-24 pr-20 pl-20  ">
        <h2 className="text-5xl font-bold mb-5 text-gray-900">Ground truth mapping</h2>
        <p className="text-gray-500  text-3xl mb-16 ">Select all appliances available in your facility</p>

        <form className="space-y-10" onSubmit={handleSubmit}>
          {/* Home Appliances */}
          <div>
            <label className="block text-3xl text-gray-700 mb-2 font-medium">Home Appliances</label>
            <div className="relative">
              <button
                type="button"
                className="w-full text-left border border-gray-300 rounded-md pr-10 pl-5 py-5 text-2xl text-gray-500 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-400"
                onClick={toggleDropdown}
              >
                {selected.length === 0 ? 'Select all the appliances used' : selected.map(val => Object.keys(HOME_APPLIANCE_VALUE_MAP).find(key => HOME_APPLIANCE_VALUE_MAP[key] === val)).join(', ')}
                <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400">
                {/* ▼ */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 10L12 15L17 10" stroke="#898989" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                </span>
              </button>
              {dropdownOpen && (
                <div className="absolute z-10 mt-2 p-4  w-full bg-white border border-gray-300 rounded shadow-lg max-h-96 overflow-y-auto grid grid-cols-3 gap-4  text-lg" style={{minWidth: '600px'}}>
                  {HOME_APPLIANCES.map((appliance) => (
                    <CustomCheckbox
                      key={appliance}
                      checked={selected.includes(HOME_APPLIANCE_VALUE_MAP[appliance])}
                      onChange={() => handleCheck(HOME_APPLIANCE_VALUE_MAP[appliance])}
                      label={appliance}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Facility Appliances */}
          <div>
            <label className="block text-3xl text-gray-700 mb-2 font-medium">Facility Appliances</label>
            <div className="relative">
              <button
                type="button"
                className="w-full text-left border border-gray-300 rounded-md pr-10 pl-5 py-5 text-2xl text-gray-500 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-400"
                onClick={toggleFacilityDropdown}
              >
                {facilitySelected.length === 0 ? 'Select all the appliances used' : facilitySelected.map(val => Object.keys(FACILITY_APPLIANCE_VALUE_MAP).find(key => FACILITY_APPLIANCE_VALUE_MAP[key] === val)).join(', ')}
                <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400">
                {/* ▼ */}
                
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 10L12 15L17 10" stroke="#898989" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                </span>
              </button>
              {facilityDropdownOpen && (
                <div className="absolute z-10 mt-2 w-full bg-white border border-gray-300 rounded shadow-lg max-h-96 overflow-y-auto grid grid-cols-3 gap-4 p-4 text-lg" style={{minWidth: '600px'}}>
                  {FACILITY_APPLIANCES.map((appliance) => (
                    <CustomCheckbox
                      key={appliance}
                      checked={facilitySelected.includes(FACILITY_APPLIANCE_VALUE_MAP[appliance])}
                      onChange={() => handleFacilityCheck(FACILITY_APPLIANCE_VALUE_MAP[appliance])}
                      label={appliance}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Others */}
          <div className=' '>
            <label className="block text-3xl text-gray-700 mb-2 font-medium">Others</label>
            <input
              type="text"
              placeholder="Indicate appliances not listed"
              className="w-full border border-gray-300 rounded-md px-5 py-5 focus:outline-none focus:ring-2 focus:ring-green-400 bg-gray-50 text-2xl mb-16"
              value={others}
              onChange={e => setOthers(e.target.value)}
            />
          </div>

          {/* Submit Button */}
          <div className='mt-20 '>
            <button type="submit" className="w-full text-2xl py-10  text-white font-semibold rounded bg-gradient-to-r from-[#038B47] to-[#00AED9] hover:from-green-700  hover:to-green-600 transition-all shadow">
            Continue
            </button>
          </div>
        </form>
      </div>
      <style>
{`
.custom-checkbox .checkbox-box {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: #fff;
  border: 2px solid transparent;
  background-clip: padding-box, border-box;
  background-origin: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  position: relative;
  background-image: linear-gradient(#fff, #fff), linear-gradient(90deg, #038B47 0%, #00AED9 100%);
}
.custom-checkbox input:focus + .checkbox-box {
  box-shadow: 0 0 0 2px #00AED933;
}
`}
</style>
    </div>
  );
}
